import React, { useEffect, useState } from 'react';
import illustration from '../../../../../images/survey/survey-1-illustration.svg';
import InputComponent from '../../../../common-components/InputComponent/InputComponent';
import CustomRadioButton from '../../../../common-components/CustomRadioButton/CustomRadioButton';
import ButtonComponent from '../../../../common-components/ButtonComponent/ButtonComponent';
import RightArrow from '../../../../Icons/icons/RightArrow';
import { useSurveyContext } from './surveyContext';
import { surveyForm1Validation } from '../../../../../utils/validationSchema';
import { updateStorageObject } from '../../../../../utils/global';
import { useFormValidation } from '../../../../../hooks/useFormValidation';
import { useSelector } from 'react-redux';
import { Mixpanel } from '../../../../../utils/mixpanel';

const RoleOptions = [
  'Founder/CEO',
  'CMO/Head of Growth',
  'Influencer Marketing Manager',
  'General Marketing Manager',
  'Other',
];

const SurveyPage1 = () => {
  const { userDetails } = useSelector((state) => state.user);
  const { setSurveyFormStep, form1Data, setForm1Data } = useSurveyContext();
  const [selectedRole, setSelectedRole] = useState(() => {
    if (form1Data.role.length) {
      if (!RoleOptions.includes(form1Data.role)) return 'Other';
      return form1Data.role;
    }
    return null;
  });
  
  const { errors, setErrors, validate } = useFormValidation(surveyForm1Validation);

  const onFormSubmit = async (e) => {
    e?.preventDefault();
    const isValid = validate(form1Data);
    if (!isValid) return;
    Mixpanel.track('onboarding_step_completed', { "Step Name": "First Step", "Step Number": 1, Responses: form1Data });
    updateStorageObject('onboarding-form-data', 'form1', form1Data);
    setSurveyFormStep(2);
  };

  useEffect(() => {
    Mixpanel.identify(userDetails?._id);
    Mixpanel.people.set({ "Onboarding Completed": false });
  }, [])
  return (
    <form onSubmit={onFormSubmit}>
      <div className="survey-1-container">
        <div className="survey-1-content">
          <div className="survey-1-form">
            <div className="survey-1-title-container">
              <div className="survey-1-title">We’re curious...</div>
              <div className="survey-1-sub-title">
                Help us understand what you’re trying to do so we can show you how to make the most out of SARAL.
              </div>
            </div>
            <InputComponent
              label={<div className="custom-large-input-label">🌐 Your brand's website</div>}
              size="large"
              placeholder="Enter website URL..."
              value={form1Data.website}
              setValue={(val) => {
                setErrors((e) => ({ ...e, website: null }));
                setForm1Data((p) => ({ ...p, website: val }));
              }}
              error={errors?.website}
            />
            <div className="survey-1-role-container">
              <div className="survey-1-role-title-container">
                <div className="custom-large-input-label">🧑🏻‍💻 Your Role </div>
                <div className="survey-1-role-sub-title">Select one of these options</div>
              </div>
              <div className="survey-1-role-option-container">
                {RoleOptions.map((text) => {
                  const isSelected = selectedRole === text;
                  const isOther = selectedRole === 'Other';
                  return (
                    <CustomRadioButton
                      key={text}
                      checked={isSelected}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setErrors((e) => ({ ...e, role: null }));
                          setSelectedRole(text);
                          let roleText;
                          if (text === 'Other') {
                            roleText = '';
                          } else {
                            roleText = text;
                          }
                          setForm1Data((p) => ({ ...p, role: roleText }));
                        }
                      }}
                      name="roleSelect"
                      text={
                        <RadioOption
                          text={text}
                          isActive={isSelected}
                          rightContent={
                            text === 'Other' ? (
                              <InputComponent
                                value={isOther ? form1Data.role : ''}
                                setValue={(val) => {
                                  setErrors((e) => ({ ...e, role: null }));
                                  setForm1Data((p) => ({ ...p, role: val }));
                                }}
                                onFocus={() => {
                                  if (selectedRole !== 'Other') {
                                    setForm1Data((p) => ({ ...p, role: '' }));
                                  }
                                  setSelectedRole(text);
                                }}
                              />
                            ) : (
                              ''
                            )
                          }
                        />
                      }
                    />
                  );
                })}
              </div>
              {errors.role && <div className="survey-error-text">{errors.role}</div>}
            </div>
          </div>
          <div className="survey-1-illustration">
            <img src={illustration} alt="illustration" />
          </div>
        </div>
        <div className="survey-1-bottom-container">
          <ButtonComponent style={{ width: '242px' }} type="submit">
            Next <RightArrow color="#fff" />
          </ButtonComponent>
        </div>
      </div>
    </form>
  );
};

const RadioOption = ({ text, isActive, rightContent }) => {
  return (
    <div className={`radio-button-text-option  ${isActive ? 'radio-button-text-option-active ' : ''}`}>
      {text} {rightContent}
    </div>
  );
};

export default SurveyPage1;
